import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
// import PageManager from "../page-manager";
import useAPI from "./Configurator/hooks/useAPI";
import LazyLoad from "react-lazyload";
import Groups from "./groups";
import GroupItem from "./group-item";

function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}
const Products = ({ context, groupId, level, forCategory }) => {
  const [products, setProducts] = useState([]);
  const [group, setGroup] = useState({});
  const [groups, setGroups] = useState([]);
  const [productsAreInContext, setProductsAreInContext] = useState(false);

  groupId = groupId || "all";

  //   const [forCategory, setForCategory] = useState(null);
  //   const [level, setLevel] = useState(1);
  const { API } = useAPI();

  //   useEffect(() => {
  //     // getAndSetForCategory();

  //     // let groupId = getQueryVariable("group");
  //     if (groupId) {
  //       console.log("Group", groupId);
  //       getAndSetProductsWithinGroupFromServer(groupId);
  //       setSelectedGroupId(groupId);
  //     } else {
  //       setProductsAreInContext(true);
  //       //   setProducts(context.category.products);TODO
  //     }

  //     // if (window.location.href.indexOf("servers") > -1) {
  //     //Only show groups for servers (NOW SHOING FOR ALL CONFIG PRODS)

  //     // }
  //   }, []);

  useEffect(() => {
    getAndSetProductsWithinGroupFromServer();
  }, [groupId, level, forCategory]);

  useEffect(() => {
    if (forCategory && level) {
      getAndSetGroups();
    }
  }, [forCategory, level]);

  const getAndSetForCategory = () => {
    let category = null;
    let url = window.location.href;
    if (url.indexOf("servers") > -1) {
      category = "servers";
    } else if (url.indexOf("storage") > -1) {
      category = "storage";
    } else if (url.indexOf("switches") > -1) {
      category = "switches";
    }
    // setForCategory(category);
  };

  const getAndSetProductsWithinGroupFromServer = async () => {
    console.log("getAndSetProductsWithinGroupFromServer()");
    let groupIdToUse = groupId || "all";
    setProducts([]);
    let data = await API.get(
      `/groups/${groupIdToUse}/products?forCategory=${forCategory}`
    );
    console.log("productsInGroup", data.products);
    setProducts(data.products);
    // setGroup(data.group);
  };

  const getAndSetGroups = async () => {
    let data = await API.get(
      `/groups?forCategory=${forCategory}&level=${level}`
    );

    setGroups(data.groups);
  };

  return (
    <div>
      <div className="sb-page-products container">
        {products.length === 0 && <p>There's no products to show.</p>}
        <ul className="sb-configurable-products">
          {products.map((product) => {
            let priceToShow;
            if (productsAreInContext) {
              priceToShow = product.price.without_tax.formatted;
            } else {
              priceToShow = "£" + product.price;
            }
            return (
              <li key={product.id}>
                <a href={`/server-configurator/?baseId=${product.id}`}>
                  <div>
                    {product.images.map((image) => {
                      let imageSrc;
                      if (productsAreInContext) {
                        //From page context
                        imageSrc = image.data.replace("{:size}", "500x500");
                      } else {
                        //From group / our server
                        imageSrc = image.url_standard;
                      }
                      return (
                        <LazyLoad>
                          <img src={imageSrc} style={{ width: "100%" }} />
                        </LazyLoad>
                      );
                    })}
                    <h3>{product.name}</h3>
                    <h6>Configure from {priceToShow}</h6>
                    {/* ({product.id}) */}
                  </div>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Products;
